/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ sayfa',
  jump_to: 'Git',
  jump_to_confirm: 'onayla',
  page: '',

  // Pagination.jsx
  prev_page: 'Ãnceki Sayfa',
  next_page: 'Sonraki Sayfa',
  prev_5: 'Ãnceki 5 Sayfa',
  next_5: 'Sonraki 5 Sayfa',
  prev_3: 'Ãnceki 3 Sayfa',
  next_3: 'Sonraki 3 Sayfa'
};
